import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import styles from './Sidebar.css';

import SidebarItem from './SidebarItem';
import SidebarPanel from './SidebarPanel';

function Sidebar({
  title,
  sidebarItems,
  sidebarHeaderImage,
  color,
  CustomHeader,
  sidebarClass,
  width,
  activeColor
}) {
  sidebarItems = sidebarItems.map((item) => {
    item.id = uuidv4();
    return item;
  });

  const [items, setItems] = useState(sidebarItems);

  function sidebarItemClicked(e) {
    setItems(
      items.map((item) => {
        if (item.id === e.id) {
          if (item.panel) {
            item.active = !item.active;
          }
          if (item.onClick) {
            item.onClick({ ...item });
          }
        } else {
          item.active = false;
        }
        return item;
      })
    );
  }

  function closeSidebarPanel() {
    setItems(
      items.map((item) => {
        item.active = false;
        return item;
      })
    );
  }

  const activeItems = items.filter(({ active }) => active);
  const activeItem = activeItems.length === 1 ? activeItems[0] : null;
  const isSidebarActive = activeItem !== null;

  return (
    <section
      style={{ backgroundColor: color }}
      className={styles.sidebar + ' mag-sidebar'}
    >
      <div
        className={sidebarClass}
        style={{ width: width ? width + 'px' : '100px' }}
      >
        {CustomHeader ? (
          <CustomHeader />
        ) : (
          <div className={styles.sidebarHeader + ' mag-sidebar-header'}>
            <img
              title={title}
              width='65'
              src={sidebarHeaderImage}
              alt='Bikemap Icon'
            ></img>
          </div>
        )}
        {title ? <h2>{title}</h2> : ''}
        {sidebarItems.map(({ label, active, iconClass, id }) => {
          return (
            <SidebarItem
              key={id}
              id={id}
              label={label}
              iconClass={iconClass}
              active={active}
              sidebarItemClicked={sidebarItemClicked}
            />
          );
        })}
      </div>
      <SidebarPanel
        isSidebarActive={isSidebarActive}
        activeItem={activeItem}
        closeSidebarPanel={closeSidebarPanel}
      />
    </section>
  );
}

export default Sidebar;
